import 'core-js';
import 'classlist-polyfill';
import 'intersection-observer';
import 'currentscript';
import 'library-@/utils/windowOpenWithNoopener';
import { container } from '@/inversify.config';
import Vue from 'vue';
import i18n from '@/locales/index.js';
import PatentView from '@/PatentView.vue';
import store from '@/vuex/store.js';
import router from '@/router/index.js';
import '@patsnap-biz/authority/src/style/authority.scss';
import './assets/styles/el-overwrites/index.scss';
import '@patsnap/common-snap-zen/src/scss/snap-zen.scss';
import '@/assets/styles/app/index.scss';
import 'library-@/highlight/scss/index.scss';
import '@patsnap-biz/design-tokens/scss/_variables-IP.css';
import 'vue-resize/dist/vue-resize.css';
import '@patsnap-biz/design-tokens/scss/_input.scss';
import './assets/styles/main.scss';
import createBridge, { createEventHub } from '@patsnap-utils/store-connect';
import { initTransformCodeInterceptor } from 'library-@/apis/interceptors/transform_code.interceptor.js';
import { getIsFamilySearch, getIsFamilySearchWithUngroup } from '@/composables/use-family-search';
import { PatsnapCopilotIntentRendererRegistry } from '@analytics/patsnap-copilot/src/patsnap-copilot-renderer';
import { setContainer } from '@patsnap/tahiti-core/ioc/inject';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { initWindowRvTrack } from '@/utils/rvTrack.js';
import { startup } from '@/startup';
import { headerService } from '@/services/header-service';
import { loadAilArms } from '@analytics/shared/utils/arms';
import { SpaMode } from '@analytics/shared/types/arms';

setContainer(container);
injectService<PatsnapCopilotIntentRendererRegistry>(PatsnapCopilotIntentRendererRegistry).onStart();

// 初始化全局埋点
initWindowRvTrack();

// 同族库搜索模式
const isFamilySearch = getIsFamilySearch();
const isFamilySearchWithUngroup = getIsFamilySearchWithUngroup();

// 建立跟fundation的连接
window.$bridge = createBridge({
    headerConfig: {
        publicModule: true,
        moduleName: 'patentView',
        inputType: (isFamilySearch || isFamilySearchWithUngroup) ? 'noInput' : undefined,
    },
});
Vue.prototype.$eventHub = createEventHub(window.$bridge);
Vue.config.productionTip = false;

async function createApp() {
    const { locale } = await startup(isFamilySearch);

    // 创建国际化相关内容
    const locales = await i18n(locale);
    initTransformCodeInterceptor(locales);

    loadAilArms({ account_id: headerService?.account?._info.account_id || '', spaMode: SpaMode.History });

    // 创建vue实例
    new Vue({
        el: '#view-root',
        // @ts-ignore
        router,
        store,
        i18n: locales,
        render: h => h(PatentView),
    });

    window.hidePageLoading && window.hidePageLoading();
}

createApp();
